import { ShopTypeSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  type_id: {
    'ui:widget': ShopTypeSelectionWidget,
  },
  conditions: {
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
